module.exports = __webpack_public_path__ + "static/img/landing-page-3@2x.c024876.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LandingPage/landing-page-3@2x.png
// module id = EE74
// module chunks = 5